export default {
  main: '#B59E6A',
  secondary: '#000000',
  contrastingColor: '#ffffff',
  priceColor: '#B59E6A',
  entryBackground: '#B59E6A',
  menuBackgroundColor: '#ffffff',
  menuTextColor: '#000000',
};
